import useAccountInfo from "@/hooks/useAccountInfo";
import { useClientFeature } from "@/hooks/useClientFeature";
import useUserPermissionsStore from "@/stores/useUserPermissionsStore";
import {
  type DashboardSurfaces,
  resolveDashboardSurfaces,
} from "@/utils/dashboardSurfaces";

export function useDashboardSurfaces(): DashboardSurfaces {
  const { isFeatureEnabled } = useClientFeature();

  const pricingTierId = useAccountInfo(
    (state) => state.accountInfo.FK_pricingTierId,
  );

  const permissions = useUserPermissionsStore((state) => state.permissions);

  const hasTaxRegister = isFeatureEnabled("taxRegister");

  return resolveDashboardSurfaces({
    pricingTierId,
    canViewAnalytics: !!permissions.view_analytics,
    canOpenPos: hasTaxRegister && !!permissions.view_pos_page,
    canOpenInvoiceArchive:
      hasTaxRegister && !!permissions.view_invoice_archive_page,
  });
}
